<template>
  <div class="goods_info2">
    <div class="left">
      <img class="goods_icon" :src="info.icon" />
      <div class="goods_desc">
        <div class="goods_name">{{ info.goods_name }}</div>
      </div>
    </div>
    <div class="right">
      <div class="total_price">&yen;{{ info.totalPrice }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "goods-info",
  props: {
    info: [Object, Array],
  },

  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.goods_info2 {
  background-color: #fff;
  padding: 1.2rem 1rem;
  display: flex;
  justify-content: space-between;
  padding: 1.2rem 1rem;
  border-top: 1px solid var(--innerbgc);
  border-bottom: 1px solid var(--innerbgc);
  min-height: 7.6rem;
  .left {
    display: flex;
    .goods_icon {
      width: 5rem;
      height: 5rem;
      border: 1px solid #999;
      border-radius: 0.3rem;
      margin-right: 0.6rem;
      box-shadow: 0 -2px 0 0 #dbdbdb, -2px 0 0 0 #dbdbdb, 2px 0 0 0 #dbdbdb,
        0 2px 0 0 #dbdbdb;
    }
    .goods_desc {
      .goods_name {
        font-size: 1.5rem;
      }
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .qf {
      color: #999;
      font-size: 1.2rem;
    }
    .total_price {
      color: #ea4d41;
      font-size: 1.3rem;
      font-weight: 700;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
